/* AlpineJS is our main JS utility framework, doc here : https://alpinejs.dev/start-here */
import Alpine from 'alpinejs';

import { gsap } from "gsap"; 
import { ScrollTrigger } from "gsap/ScrollTrigger"; 
gsap.registerPlugin(ScrollTrigger);

import BiggerPicture from "bigger-picture";


/* Common */   
import { initAlpineJs } from './components/common/Alpine.js' 
import StickyHeader from "./components/common/StickyHeader.js";   
import FooterLogosSliders from "./components/common/FooterLogosSliders.js";   
import TestimonialsSliders from "./components/common/TestimonialsSliders.js";
import ImagesTextSlider from "./components/common/ImagesTextSlider.js";
import ActivitiesSlider from "./components/common/ActivitiesSlider.js";
import GallerySliders from "./components/common/GallerySlider.js";
import HomeText from "./components/common/HomeText.js";
import Map from "./components/common/Map.js";
import MapText from "./components/common/MapText.js";
import Slider from "./components/common/Slider";  
import Archive from "./components/common/Archive"; 
import Anchors from "./components/common/Anchors.js"; 
import Anime from "./components/common/Anime";  
import SlidebookerLinks from './components/common/SlidebookerLinks';

// import 'swiper/css'; 
// import 'swiper/css/navigation';
// import 'swiper/css/pagination';
// import 'swiper/css/effect-fade';
 
// import "bigger-picture/css"; 

/* Blocks */  

const components = {   

	slider	: {
		component : Slider,
	}, 
	archive	: {
		component : Archive,
	},
	anchors	: {
		component : Anchors,
	},
	anime	: {
		component : Anime,
	}
} 

 
/**
 * Init Components 
 */
const initComponents = () => {   
	
	for(var [key, values] of Object.entries(components)){

		const Component = values.component;

		if(values.active != false) {
			
			const elms = [...document.querySelectorAll(`[data-hwc-${key}]`)];

			if(elms.length){
				
				elms.forEach((el) => { 
					new Component(el);  
				});

			}else if (values.force == true){

				new Component(); 

			}

		}

	}  

  	ScrollTrigger.refresh();

}  
 

document.addEventListener('DOMContentLoaded', () => {
  
	window.Alpine = Alpine
	Alpine.start();  

	
	// ---------

	new SlidebookerLinks();

	// ---------

	const homeTextElms = document.querySelectorAll('[data-hwc-hometext]');

	if(homeTextElms.length){

		homeTextElms.forEach((blockElm) => {
			new HomeText(blockElm);
		});

	}


	// ---------

	const testimonialsSlidersElms = document.querySelectorAll('[data-hwc-testimonials-slider]');

	if(testimonialsSlidersElms.length){

		testimonialsSlidersElms.forEach((sliderElm) => {
			new TestimonialsSliders(sliderElm);
		});

	}

	// ---------

	const mapsElms = document.querySelectorAll('[data-hwc-map]');

	if(mapsElms.length){

		mapsElms.forEach((mapElm) => {
			new Map(mapElm);
		});

	}

	// ---------

	const mapTextElms = document.querySelectorAll('[data-hwc-map-text]');

	if(mapTextElms.length){

		mapTextElms.forEach((mapElm) => {
			new MapText(mapElm);
		});

	}

	// ---------

	const gallerySlidersElms = document.querySelectorAll('[data-hwc-gallery-slider]');

	if(gallerySlidersElms.length){

		gallerySlidersElms.forEach((sliderElm) => {
			new GallerySliders(sliderElm);
		});

	}

	// ---------

	const imagestextSlidersElms = document.querySelectorAll('[data-hwc-imagestext-slider]');

	if(imagestextSlidersElms.length){

		imagestextSlidersElms.forEach((sliderElm) => {
			new ImagesTextSlider(sliderElm);
		});

	}

	// ---------

	const activitiesSlidersElms = document.querySelectorAll('[data-hwc-activities-slider]');

	if(activitiesSlidersElms.length){

		activitiesSlidersElms.forEach((sliderElm) => {
			new ActivitiesSlider(sliderElm);
		});

	}

	// ---------

	// let lightboxesElms = document.querySelectorAll('[data-hwc-lightbox]');

	// if(lightboxesElms.length && typeof BiggerPicture === "function"){

	// 	lightboxesElms.forEach((lightboxElm) => {

	// 		new ImagesLightboxes(lightboxElm);

	// 	});

	// }

	if (typeof BiggerPicture === "function") { 
		
		let bigPicture = BiggerPicture({
			target: document.body
		});

		let links = document.querySelectorAll('.js-open-lightbox');

		for (let link of links) {

			link.addEventListener("click", openBiggerPicture);

		}  

		function openBiggerPicture(e) {

			e.preventDefault(); 

			bigPicture.open({
				items	: e.currentTarget,
				el		: e.currentTarget, 
			});

		}


		let homeBP = BiggerPicture({
			target: document.body
		});


		function initCloseBP(){
			
			let bpCloseBtns = document.querySelectorAll('.item-closeBtn');

			for (let bpCloseBtn of bpCloseBtns) {

				bpCloseBtn.addEventListener("click", function(){
				
					homeBP.close();

				});

			} 
			
			
		}

		let onloadLightbox = document.querySelector('.js-open-lightbox-onload');
		let openLightbox = !(getWithExpiry('hwcViewedLightbox') == 'true');
		
		if(onloadLightbox && openLightbox){
		
			
			window.setTimeout(function(){

				homeBP.open({
					noClose		: true,	
					intro     	: "fadeup",
					items	    : onloadLightbox.querySelector('.js-lightbox-item'),
					onClosed(){          
						
						setViewedCookie();

					},
					onOpen(container){
						
						var lightboxLink = container.querySelector('.js-lightbox-link');
						
						if(lightboxLink){
							
							lightboxLink.addEventListener('click', function(){        
								
								setViewedCookie();      
								
								homeBP.close();

							}); 

						}

					}, 		
					onUpdate(){

						initCloseBP();

					}	
				});

			}, 1500);

		}
		

		function setViewedCookie(){

			setWithExpiry( 'hwcViewedLightbox', 'true', 1000 * 60 * 60 * 24 * 1);

		}


	}



	// ---------

	const stickyHeaderElm = document.querySelector('[data-hwc-sticky]');
	if(stickyHeaderElm){
		
		new StickyHeader(stickyHeaderElm);

	}


	// ---------

	const footerLogosSlidersElms = document.querySelectorAll('[data-hwc-footer-logos-slider]');

	if(footerLogosSlidersElms.length){

		footerLogosSlidersElms.forEach((sliderElm) => {
			new FooterLogosSliders(sliderElm);
		});

	}

	// ---------

	function scrollToTargetAdjusted(element, headerOffset = 0){

		var elementPosition = element.getBoundingClientRect().top;
		var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

		window.scrollTo({
			top			  : offsetPosition,
			behavior	: "smooth"
		});

	}

	var wpcf7Elms = document.querySelectorAll('.wpcf7');

	if(wpcf7Elms.length){

		wpcf7Elms.forEach((wpcf7Elm) => {
		
			wpcf7Elm.addEventListener('wpcf7mailsent', function(evt){				
				scrollToAfterCF7Submit(evt);				
			}, false );
			
			wpcf7Elm.addEventListener('wpcf7spam', function(evt){
				scrollToAfterCF7Submit(evt);
			}, false );

			wpcf7Elm.addEventListener('wpcf7invalid', function(evt){
				scrollToAfterCF7Submit(evt);
			}, false );

			wpcf7Elm.addEventListener('wpcf7mailfailed', function(evt){
				scrollToAfterCF7Submit(evt);
			}, false );
			
			wpcf7Elm.addEventListener('wpcf7submit', function(evt){
				scrollToAfterCF7Submit(evt);
			}, false );

		});

	}

	function scrollToAfterCF7Submit(evt){
		
		var targetElm = evt.target.querySelector('.wpcf7-response-output');
			
		scrollToTargetAdjusted(targetElm, 84); 
	
	}
 
	/* Init anchors */

	const params = new URLSearchParams(window.location.search);
	const anchor = params.get("anchor");
	if (anchor){ 
			const target = document.querySelector(`[data-anchors-section="${anchor}"]`); 
			if( target ){ 
				setTimeout(() => {
					window.scrollTo({
						top: target.offsetTop,
						behavior: "smooth"
					});
				}, 200); 
			}
		}

	// ---------

  	initComponents();   
   
	// ---------

	document.body.classList.add('is-domready');

});


window.addEventListener('load', () => {
	
	document.body.classList.add('is-loaded');

});

 
document.addEventListener('alpine:init', () => {
  	
	initAlpineJs();

});


window.setWithExpiry = function(key, value, ttl) {

	const now = new Date();

	const item = {
		value	: value,
		expiry	: now.getTime() + ttl,
	};

	localStorage.setItem(key, JSON.stringify(item));

};

window.getWithExpiry = function(key) {

	const itemStr = localStorage.getItem(key);
	
	if (!itemStr) {
		return null;
	}

	const item = JSON.parse(itemStr);
	const now = new Date();

	if (now.getTime() > item.expiry) {
		localStorage.removeItem(key);
		return null;
	}

	return item.value;

};
